module.exports = __webpack_public_path__ + "img/searouter-logo.a6d6b5a8.png";